module.exports = __webpack_public_path__ + "img/frame (229).bf541166.jpg";